import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Departement } from '../model/departement';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';

@Injectable({
    providedIn: 'root'
  })
  export class DepartementService{
  
    constructor(private _restClientService : RestClientService) { }
    
     
    getAllDepartements() {
        return this._restClientService.load<Departement[]>('departement/departements');
    }

    getDepartementsByDirection(directionid) {
      return this._restClientService.load<Departement[]>('departement/departements-by-direction?directionid='+directionid);
    }

    getDepartementsByDirectionCode(directioncode) {
      return this._restClientService.load<Departement[]>('departement/departements-by-directioncode?directioncode='+directioncode);
    }
          
    getDepartementById(departementId)
    {
      return this._restClientService.load<Departement>('departement/get/'+departementId);
    }
 
    getDepartementByCode(departementCode)
    {
      return this._restClientService.load<Departement>('departement/get-by-code/'+departementCode);
    }

    putDepartement(departement) 
    {
      return  this._restClientService.put<Departement>(`departement/update`, departement);
    }

    postDepartement(departement) 
    {
      return  this._restClientService.save<Departement>('departement/add', departement);
    }


  


}      

    